import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "className", "setImgPreview", "addUploadImg", "zoneType", "attachmentConfig", "onImageChange", "imageRef"];
import React, { useRef } from 'react';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { IconPaperclip } from '@carnica/graphics';
import { cnBem } from '@carnica/utils';
import { connect } from 'react-redux';
import { Button, ContextMenu } from "../../../../shared/ui";
import { getChatWidgetNode } from "../../../../shared/lib";
import { selectAttachmentsConfig, selectChatCofig } from "../../../../entities/settings/model";
import { defaultAttachmentSettings } from "../../../../shared/config";
import { selectIsImgPreviewOpen } from "../../../../entities/message/model";
import { useFileLoad } from "../../lib/hooks/useFileLoad";
import { useAttachment } from "../../lib/hooks/useAttachment";
import styles from "./styles.pcss";
var cnAttachment = cnBem('attachment', styles);
var AttachmentRender = function AttachmentRender(_ref) {
  var onChange = _ref.onChange,
    className = _ref.className,
    setImgPreview = _ref.setImgPreview,
    addUploadImg = _ref.addUploadImg,
    zoneType = _ref.zoneType,
    attachmentConfig = _ref.attachmentConfig,
    onImageChange = _ref.onImageChange,
    imageRef = _ref.imageRef,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var container = getChatWidgetNode();
  var acceptFile = (attachmentConfig === null || attachmentConfig === void 0 ? void 0 : attachmentConfig.file) || '.doc,.docx';
  var acceptImage = (attachmentConfig === null || attachmentConfig === void 0 ? void 0 : attachmentConfig.image) || 'image/*';
  var buttonRef = useRef(null);
  var _useFileLoad = useFileLoad(),
    fileRef = _useFileLoad.fileRef,
    handleFileLoad = _useFileLoad.handleFileLoad;
  var _useAttachment = useAttachment({
      imageRef: imageRef,
      fileRef: fileRef,
      acceptImage: acceptImage,
      acceptFile: acceptFile,
      onImageChange: onImageChange,
      handleFileLoad: handleFileLoad
    }),
    items = _useAttachment.items,
    isOpen = _useAttachment.isOpen,
    handleImageChange = _useAttachment.handleImageChange,
    handleFileChange = _useAttachment.handleFileChange,
    handleAttachClick = _useAttachment.handleAttachClick,
    handleClickOutside = _useAttachment.handleClickOutside;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    accept: acceptFile,
    className: cnAttachment('hidden'),
    onChange: handleFileChange,
    ref: fileRef,
    type: "file",
    "data-t-id": "ui-Attachment"
  }), /*#__PURE__*/React.createElement("input", {
    accept: acceptImage,
    className: cnAttachment('hidden'),
    onChange: handleImageChange,
    ref: imageRef,
    type: "file"
  }), /*#__PURE__*/React.createElement(Button, _extends({}, otherProps, {
    "aria-label": "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0444\u0430\u0439\u043B\u044B",
    className: cnAttachment(null, [className]),
    iconColor: "tertiary",
    iconLeft: IconPaperclip,
    onClick: handleAttachClick,
    onlyIcon: true,
    ref: buttonRef,
    size: "m",
    view: "tertiary-invert"
  })), /*#__PURE__*/React.createElement(ContextMenu, {
    anchorRef: buttonRef,
    className: cnAttachment('container'),
    container: container,
    direction: "upStartLeft",
    isOpen: isOpen,
    isProportional: true,
    items: items,
    offsetVertical: 12,
    onClickOutside: handleClickOutside
  }));
};
export var Attachment = compose(connect(function (store) {
  var _selectAttachmentsCon = selectAttachmentsConfig(store),
    isEnabled = _selectAttachmentsCon.isEnabled,
    image = _selectAttachmentsCon.image,
    file = _selectAttachmentsCon.file;
  var _selectChatCofig = selectChatCofig(store),
    authZoneConfig = _selectChatCofig.authZoneConfig;
  var isAuthorized = authZoneConfig.zoneType === 'authorized';
  return {
    attachmentConfig: {
      image: (image === null || image === void 0 ? void 0 : image.formatList) || defaultAttachmentSettings.image,
      file: (file === null || file === void 0 ? void 0 : file.formatList) || defaultAttachmentSettings.file
    },
    shouldRender: isEnabled && isAuthorized && !selectIsImgPreviewOpen(store)
  };
}), withRenderFlag)(AttachmentRender);